import { useForm } from 'react-hook-form';
import { SchedulingPreferences } from '../../../hooks/useSchedulingPreferences/types';
import { parseAvailability } from './parseAvailability';
import { SchedulingPreferencesFormValues } from './types';

export { default as parseAvailability } from './parseAvailability';
export { default as formatAvailability } from './formatAvailability';
import { getCurrentTimeZoneId } from '../../../../meetings/schedule/timeZoneId';
import { prepareAvailabilityByTotalTime } from '../helpers';

export const withDefaults = (
    schedulingPreferences: SchedulingPreferences
): SchedulingPreferencesFormValues => {
    const timezoneId = getCurrentTimeZoneId();
    return {
        timezoneId,
        meetingDuration: schedulingPreferences?.meetingDuration,
        bufferTime: schedulingPreferences?.bufferTime,
        leadTime: schedulingPreferences?.leadTime,
        maxMeetingsPerDay: schedulingPreferences?.maxMeetingsPerDay,
        availability:
            prepareAvailabilityByTotalTime(
                parseAvailability(schedulingPreferences?.schedulingHours, timezoneId),
                schedulingPreferences?.schedulingHoursBase,
                timezoneId
            ) ?? [],
    };
};

const useSchedulingPreferencesForm = (defaultValues: SchedulingPreferencesFormValues) =>
    useForm<SchedulingPreferencesFormValues>({
        defaultValues,
        mode: 'onChange',
    });

export default useSchedulingPreferencesForm;
